import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { locationsRoute } from 'src/app/app-routing.module';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import { LocationDetailSaveModel } from '../../location-details/models/location-detail-save.model';
import { locationsRegisterAdapterActions } from '../../locations-register-component/state/locations-register.actions';
import { AddLocationApiService } from '../services/add-location-api.service';
import * as AddLocationActions from './add-location.actions';

@Injectable()
export class AddLocationEffects {
   createLocation$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(AddLocationActions.createLocation),
         withLatestFrom(this.store.select(getSelectedAccountId)),
         switchMap(([action, accountId]) => {
            const locationToSave: LocationDetailSaveModel = {
               ...action.location,
               accountId: accountId ?? 0,
            };
            return this.addLocationApiService.create(locationToSave).pipe(
               map((executionResult) => {
                  return AddLocationActions.createLocationSuccess({
                     locationId: executionResult.data.location.locationId,
                  });
               }),
               catchError((error) => {
                  return of(AddLocationActions.createLocationFailure(error));
               })
            );
         })
      );
   });

   createLocationAndAddAnother$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(AddLocationActions.createLocationAndAddAnother),
         withLatestFrom(this.store.select(getSelectedAccountId)),
         switchMap(([action, accountId]) => {
            const locationToSave: LocationDetailSaveModel = {
               ...action.location,
               accountId: accountId ?? 0,
            };
            return this.addLocationApiService.create(locationToSave).pipe(
               map((executionResult) => {
                  return AddLocationActions.createLocationAndAddAnotherSuccess({
                     locationId: executionResult.data.location.locationId,
                  });
               }),
               catchError((error) => {
                  return of(AddLocationActions.createLocationAndAddAnotherFailure(error));
               })
            );
         })
      );
   });

   createLocationAndAddAnotherSuccess$ = createEffect(
      () => {
         return this.actions$.pipe(
            ofType(AddLocationActions.createLocationAndAddAnotherSuccess),
            tap((result) => {
               this.snackbar.open('Location Created');
               this.store.dispatch(locationsRegisterAdapterActions.loadPage());
            })
         );
      },
      {
         dispatch: false,
      }
   );

   createLocationSuccess$ = createEffect(
      () => {
         return this.actions$.pipe(
            ofType(AddLocationActions.createLocationSuccess),
            tap((result) => {
               this.dialogService.closeFormComponent();
               this.router.navigate([`/${locationsRoute}/${result.locationId}`]);
               this.snackbar.open('Location Created');
            })
         );
      },
      {
         dispatch: false,
      }
   );

   constructor(
      private actions$: Actions,
      private addLocationApiService: AddLocationApiService,
      private store: Store,
      private snackbar: MatSnackBar,
      private dialogService: LcsDialogService,
      private router: Router
   ) {}
}
